import './styles/app.scss';
import React from 'react';
import { render } from 'react-dom';
import App from './components/App';

render(<App />, document.querySelector('#app'));



/** WEBPACK FOOTER **
 ** ./app/index.js
 **/